// First sign-in after an admin added the person (or reset their password): the one-time password is replaced by
// their own. The same form as My account.
import { ChangePasswordForm } from '@/features/account'
import { AuthLayout } from './AuthLayout'

export function NewPasswordStep() {
  return (
    <AuthLayout
      title="Choose your password"
      subtitle="Welcome. Replace the one-time password your admin gave you: at least 12 characters, only you know it."
    >
      <ChangePasswordForm currentLabel="One-time password (from your admin)" submitText="Save and continue" />
    </AuthLayout>
  )
}
